<template>
  <div id="cvcCard">
    <el-card
      class="clear-card cvcReview"
      :class="['mobile', 'tablet'].includes($mq) ? 'mobileMode' : 'deskMode'"
      shadow="hover"
      :body-style="{
        height: 'calc(100% - 95px)',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
      }"
    >
      <div
        slot="header"
        class="header defaultCursor"
      >
        <span>{{ $t('coach.leader.cvc.title') }}</span>
      </div>

      <div class="content">
        <el-button
          type="primary"
          round
          @click="showCvc = true"
        >
          {{ $t('common.viewReport') }}
        </el-button>
      </div>
    </el-card>

    <CvcReport
      :show.sync="showCvc"
      :engagement="engagement"
    />
  </div>
</template>

<script>
import CvcReport from '../../../common/cvc/CvcReport.vue';

export default {
  components: {
    CvcReport,
  },

  props: {
    engagement: {
      type: String,
      default: null,
    },
  },

  data: () => ({
    showCvc: false,
  }),
};
</script>

<style lang="scss" scoped>
  #cvcCard {
    .cvcReview {
      .header {
        text-align: center;
        font-weight: bold;
      }

      .content {
        text-align: center;

        .el-button {
          padding: 13px 0;
          border-width: 3px;
          width: 50%;
          min-width: 100px;
          max-width: 180px;

          &.el-button--plain {
            border-color: white;
            border-width: 1px;
          }

          &.el-button--primary {
            background: transparent;
            border: 1px solid var(--themeFontColor);
            color: var(--themeFontColor);
          }
        }
      }
    }
  }
</style>

<style lang="scss">
  #cvcCard {
    .cvcReview {
      &.mobileMode {
        .el-card__header {
          border-bottom: none !important;
        }
      }
    }
  }
</style>
